
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/the-brand/[path]",
      function () {
        return require("private-next-pages/the-brand/[path]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/the-brand/[path]"])
      });
    }
  